export default "__VITE_ASSET__Ddh6jKHz__"